import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 16,
    color: theme.primary.p2,
  },
  sharedIcons: {
    ...dFlex(),
    gap: 24,
  },
  linkString: {
    width: 227,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: 220,
    },
  },

  btn: {
    ...dFlex(),

    svg: {
      padding: 10,
      fontSize: 48,
      color: theme.secondary.s3,
      border: `1px solid ${theme.secondary.s3}`,
      borderRadius: theme.borderRadius.xxl,

      '&:hover': {
        color: theme.primary.p3,
        border: `1px solid ${theme.primary.p3}`,
      },
    },
  },
  desc: {
    flexDirection: 'column',
  },
  content: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 8,
  },
}));

export default useStyles;
